import { createContext, useContext, useState, type ReactNode } from 'react'

interface ModalLockContextValue {
  isLocked: boolean
  acquireLock: () => void
  releaseLock: () => void
}

export const ModalLockContext = createContext<
  ModalLockContextValue | undefined
>(undefined)

export const useModalLock = () => {
  const context = useContext(ModalLockContext)
  if (!context) {
    throw new Error('useModalLock must be used within a ModalLockProvider')
  }
  return context
}

interface ModalLockProviderProps {
  children: ReactNode
}

export const ModalLockProvider = ({ children }: ModalLockProviderProps) => {
  const [isLocked, setIsLocked] = useState(false)

  const acquireLock = () => {
    setIsLocked(true)
  }

  const releaseLock = () => {
    setIsLocked(false)
  }

  return (
    <ModalLockContext.Provider value={{ isLocked, acquireLock, releaseLock }}>
      {children}
    </ModalLockContext.Provider>
  )
}
